const headers = {
  name: "Project task",
  navigate: {
    path: [
      {
        name: "Tasks",
        path: "/app/projects/tasks",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
